import { render, staticRenderFns } from "./CelebrityList.vue?vue&type=template&id=45eae5f1&"
import script from "./CelebrityList.vue?vue&type=script&lang=js&"
export * from "./CelebrityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports